/** Renders the operator's manual once, into the help modal. */

import { MANUAL } from '../../data/manual.ts';
import { byId } from '../dom.ts';

export function buildManual(): void {
  const mount = byId('manual-body');
  if (mount.childElementCount > 0) return;

  for (const section of MANUAL) {
    const heading = document.createElement('h3');
    heading.className = 'manual__title';
    heading.textContent = section.title;
    mount.append(heading);

    const list = document.createElement('ul');
    list.className = 'manual__list';
    for (const line of section.lines) {
      const item = document.createElement('li');
      item.textContent = line;
      list.append(item);
    }
    mount.append(list);
  }
}
